export const IMAGE_PLACEHOLDER_URL = '/img/placeholder.svg';
export const AVATAR_PLACEHOLDER_URL = '/img/default-avatar.png';
